// Fallback function for when the API doesn't return videos
// Provides curated actual video URLs across YouTube, TikTok, and Instagram

// Curated day-in-the-life videos by category
const CURATED_VIDEOS = {
  tech: [
    {
      id: 'yt-tech-1',
      platform: 'YouTube',
      title: 'Day in the Life of a Software Engineer',
      creator: 'Joma Tech',
      url: 'https://www.youtube.com/watch?v=rqX8PFcOpxA',
      thumbnail: 'https://img.youtube.com/vi/rqX8PFcOpxA/hqdefault.jpg',
    },
    {
      id: 'yt-tech-2',
      platform: 'YouTube',
      title: 'A Day in My Life as a Google Engineer',
      creator: 'TechLead',
      url: 'https://www.youtube.com/watch?v=_luhn7TLfWU',
      thumbnail: 'https://img.youtube.com/vi/_luhn7TLfWU/hqdefault.jpg',
    },
    {
      id: 'tt-tech-1',
      platform: 'TikTok',
      title: 'Software Engineer Day in the Life',
      creator: '@techcareers',
      url: 'https://www.tiktok.com/@niikiiiita/video/7298458562447916321',
      thumbnail: null,
    },
  ],
  product: [
    {
      id: 'yt-pm-1',
      platform: 'YouTube',
      title: 'Day in the Life of a Product Manager',
      creator: 'Lenny Rachitsky',
      url: 'https://www.youtube.com/watch?v=R0gv7V7QLKA',
      thumbnail: 'https://img.youtube.com/vi/R0gv7V7QLKA/hqdefault.jpg',
    },
    {
      id: 'yt-pm-2',
      platform: 'YouTube',
      title: 'What Does a Product Manager Actually Do?',
      creator: 'Exponent',
      url: 'https://www.youtube.com/watch?v=yUOC-Y0f5ZQ',
      thumbnail: 'https://img.youtube.com/vi/yUOC-Y0f5ZQ/hqdefault.jpg',
    },
  ],
  data: [
    {
      id: 'yt-data-1',
      platform: 'YouTube',
      title: 'Day in the Life of a Data Scientist',
      creator: 'Ken Jee',
      url: 'https://www.youtube.com/watch?v=Ck0ozfJV9-g',
      thumbnail: 'https://img.youtube.com/vi/Ck0ozfJV9-g/hqdefault.jpg',
    },
    {
      id: 'yt-data-2',
      platform: 'YouTube',
      title: 'What I Do as a Data Analyst',
      creator: 'Alex The Analyst',
      url: 'https://www.youtube.com/watch?v=lJxFxgSU6ls',
      thumbnail: 'https://img.youtube.com/vi/lJxFxgSU6ls/hqdefault.jpg',
    },
  ],
  design: [
    {
      id: 'yt-design-1',
      platform: 'YouTube',
      title: 'Day in the Life of a UX Designer',
      creator: 'Flux Academy',
      url: 'https://www.youtube.com/watch?v=VvPtQrfiQBk',
      thumbnail: 'https://img.youtube.com/vi/VvPtQrfiQBk/hqdefault.jpg',
    },
  ],
  finance: [
    {
      id: 'yt-finance-1',
      platform: 'YouTube',
      title: 'Day in the Life of an Investment Banker',
      creator: 'Rareliquid',
      url: 'https://www.youtube.com/watch?v=d2bNPhfRDvA',
      thumbnail: 'https://img.youtube.com/vi/d2bNPhfRDvA/hqdefault.jpg',
    },
  ],
  consulting: [
    {
      id: 'yt-consulting-1',
      platform: 'YouTube',
      title: 'Day in the Life of a Consultant',
      creator: 'Firm Learning',
      url: 'https://www.youtube.com/watch?v=oNFnHnfzrOA',
      thumbnail: 'https://img.youtube.com/vi/oNFnHnfzrOA/hqdefault.jpg',
    },
  ],
  marketing: [
    {
      id: 'yt-marketing-1',
      platform: 'YouTube',
      title: 'Day in the Life of a Marketing Manager',
      creator: 'HubSpot',
      url: 'https://www.youtube.com/watch?v=sPz6ejWzbyQ',
      thumbnail: 'https://img.youtube.com/vi/sPz6ejWzbyQ/hqdefault.jpg',
    },
  ],
  general: [
    {
      id: 'yt-general-1',
      platform: 'YouTube',
      title: 'My 9-5 Work Day Routine',
      creator: 'Career Vlogger',
      url: 'https://www.youtube.com/watch?v=DSn-X9Pv2N8',
      thumbnail: 'https://img.youtube.com/vi/DSn-X9Pv2N8/hqdefault.jpg',
    },
    {
      id: 'yt-general-2',
      platform: 'YouTube',
      title: 'A Day in My Life Working From Home',
      creator: 'Remote Worker',
      url: 'https://www.youtube.com/watch?v=snAhsXyO3Ck',
      thumbnail: 'https://img.youtube.com/vi/snAhsXyO3Ck/hqdefault.jpg',
    },
  ],
};

// Detect category from role title
function detectCategory(roleTitle) {
  const lower = roleTitle.toLowerCase();

  if (lower.includes('software') || lower.includes('engineer') || lower.includes('developer') || lower.includes('programming')) {
    return 'tech';
  }
  if (lower.includes('product manager') || lower.includes('product management') || lower.includes('pm')) {
    return 'product';
  }
  if (lower.includes('data') || lower.includes('analyst') || lower.includes('scientist') || lower.includes('analytics')) {
    return 'data';
  }
  if (lower.includes('design') || lower.includes('ux') || lower.includes('ui') || lower.includes('creative')) {
    return 'design';
  }
  if (lower.includes('finance') || lower.includes('banking') || lower.includes('investment') || lower.includes('financial')) {
    return 'finance';
  }
  if (lower.includes('consult') || lower.includes('strategy')) {
    return 'consulting';
  }
  if (lower.includes('marketing') || lower.includes('brand') || lower.includes('social media') || lower.includes('content')) {
    return 'marketing';
  }

  return 'general';
}

export function getDayInLifeVideos(roleTitle = 'career') {
  const category = detectCategory(roleTitle);
  const categoryVideos = CURATED_VIDEOS[category] || [];
  const generalVideos = CURATED_VIDEOS.general || [];

  // Combine category-specific and general videos
  let videos = [...categoryVideos];

  // Add general videos if we don't have enough
  if (videos.length < 3) {
    const additionalVideos = generalVideos.filter(
      v => !videos.some(existing => existing.id === v.id)
    );
    videos = [...videos, ...additionalVideos];
  }

  // Ensure at least 3 videos
  return videos.slice(0, 5).map(v => ({
    ...v,
    viewCount: null,
    viewCountFormatted: null,
  }));
}

// Legacy export for backwards compatibility
export function getFallbackDayInLifeVideos(roleTitle = 'career') {
  return getDayInLifeVideos(roleTitle);
}
